const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
export const adminProductId = value => {
  if (typeof value !== 'number' && (typeof value !== 'string' || !/^\d+$/.test(value))) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};
const isoTime = value => value === null || typeof value === 'string' &&
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.test(value) && Number.isFinite(Date.parse(value));
const invalid = () => {throw new Error('Stock evidence response is not confirmed for this product');};
export function normalizeAdminStockEvidence(payload, expectedProductId) {
  const productId = adminProductId(expectedProductId);
  if (!productId || !record(payload)) return invalid();
  if (payload.enabled === false) return {mode: 'legacy', productId, evidence: null};
  if (payload.enabled !== true || payload.readOnlyStock !== true || payload.productId !== productId ||
      !isoTime(payload.generatedAt) || payload.generatedAt === null || !Array.isArray(payload.colors)) return invalid();
  const childIds = new Set();
  for (const color of payload.colors) {
    if (!record(color) || adminProductId(color.childProductId) !== color.childProductId || childIds.has(color.childProductId) ||
        typeof color.published !== 'boolean' || typeof color.isCertificate !== 'boolean' || !Array.isArray(color.sizes)) return invalid();
    childIds.add(color.childProductId);
    const names = new Set();
    const sizeIds = new Set();
    for (const size of color.sizes) {
      if (!record(size) || typeof size.sizeName !== 'string' || !size.sizeName.trim() || names.has(size.sizeName) ||
          (size.sizeId !== null && (adminProductId(size.sizeId) !== size.sizeId || sizeIds.has(size.sizeId))) ||
          typeof size.assortmentEnabled !== 'boolean' || !record(size.stock)) return invalid();
      names.add(size.sizeName); if (size.sizeId !== null) sizeIds.add(size.sizeId);
      const stock = size.stock;
      const known = stock.state === 'confirmed' || stock.state === 'stale';
      if (!['confirmed', 'stale', 'unknown', 'not_applicable'].includes(stock.state) ||
          typeof stock.reasonCode !== 'string' || !stock.reasonCode || stock.reasonCode.length > 256 ||
          !isoTime(stock.sourceAsOf) || !isoTime(stock.confirmedAt) ||
          (known ? !Number.isSafeInteger(stock.quantity) || stock.quantity < 0 || stock.sourceAsOf === null || stock.confirmedAt === null
            : stock.quantity !== null) || (stock.state === 'not_applicable' && color.isCertificate !== true)) return invalid();
    }
  }
  return {mode: 'admin', productId, evidence: payload};
}

export function adminColorEvidence(state, productId, childProductId) {
  if (state?.mode !== 'admin' || state.status !== 'ready' || state.productId !== adminProductId(productId)) return null;
  try {
    const verified = normalizeAdminStockEvidence(state.evidence, productId);
    return verified.evidence?.colors.find(color => color.childProductId === adminProductId(childProductId)) || null;
  } catch {return null;}
}
export function canEditAdminAvailability(state, productId, childProductId, isCertificate) {
  if (state?.status !== 'ready' || state.productId !== adminProductId(productId)) return false;
  if (state.mode === 'legacy') return true;
  return isCertificate === true && adminColorEvidence(state, productId, childProductId)?.isCertificate === true;
}
